/* eslint-disable no-shadow */
export enum CALENDAR_VIEW {
  AGENDA = 'agenda',
  WEEK = 'week',
  DAY = 'day',
  THREE_DAYS = 'threeDays',
  MONTH = 'month'
}

export enum EVENT_TYPE {
  NORMAL = 'normal',
  MONTH = 'month',
  AGENDA = 'agenda',
  HEADER = 'header',
  SHOW_MORE_MONTH = 'showMoreMonth'
}

export enum CALENDAR_NAVIGATION_DIRECTION {
  FORWARD = 'forward',
  BACKWARDS = 'backwards',
  TODAY = 'today'
}

export enum WEEKDAY_START {
  MONDAY = 'MONDAY',
  SUNDAY = 'SUNDAY',
  UNKNOWN = 'UNKNOWN'
}

export enum TIME_FORMAT {
  H_24 = '24',
  H_12 = '12'
}
